import { render, staticRenderFns } from "./BtnMenu.vue?vue&type=template&id=0c31b153&scoped=true"
import script from "./BtnMenu.vue?vue&type=script&lang=js"
export * from "./BtnMenu.vue?vue&type=script&lang=js"
import style0 from "./BtnMenu.vue?vue&type=style&index=0&id=0c31b153&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c31b153",
  null
  
)

export default component.exports